import { useIntl } from 'react-intl';

import { paths } from '@/lib/paths';
import { commonMessages } from '@/messages/common';

import bag from '@/assets/bag.png';

import * as S from './EmptyShoppingBag.styles';
import * as M from './messages';

export const EmptyShoppingBagContent = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <S.BagImageWrapper data-test-id='EmptyShoppingBagBagImageWrapper'>
        <S.BagImage
          alt='bag image'
          data-test-id='EmptyShoppingBagBagImage'
          fill
          priority
          sizes='10vw'
          src={bag}
        />
      </S.BagImageWrapper>
      <S.YourShoppingBagIsEmpty data-test-id='EmptyShoppingBagYourShoppingBagIsEmpty'>
        {M.YourShoppingBagIsEmpty}
      </S.YourShoppingBagIsEmpty>
      <S.FreeShippingAndReturns data-test-id='EmptyShoppingBagFreeShippingAndReturns'>
        {M.FreeShippingAndReturns}.
      </S.FreeShippingAndReturns>
      <S.ContinueShoppingButton
        data-test-id='EmptyShoppingBagContinueShoppingButton'
        href={paths.watches.asPath()}
        label={formatMessage(commonMessages.continueShopping)}
        variant='outlined'
      />
    </>
  );
};

export default EmptyShoppingBagContent;
